<template>
  <div class="inputs">
    <number-input label="Bill" :url="getDollarIconPath" v-model.number="bill" />
    <the-calculator-percentage-panel />
    <number-input
      label="Number of People"
      :url="getPersonIconPath"
      v-model.number="numberOfPeople"
    />
  </div>
</template>

<script lang="ts">
import store from '@/store';
import { SET_BILL, SET_NUMBER_OF_PEOPLE } from '@/store/mutations';
import { defineComponent } from 'vue';
import NumberInput from './NumberInput.vue';
import TheCalculatorPercentagePanel from './TheCalculatorPercentagePanel.vue';

export default defineComponent({
  name: 'the-calculator-inputs-panel',
  components: { NumberInput, TheCalculatorPercentagePanel },
  data() {
    return { bill: '', numberOfPeople: '' };
  },
  computed: {
    getDollarIconPath() {
      return require('@/assets/icon-dollar.svg');
    },
    getPersonIconPath() {
      return require('@/assets/icon-person.svg');
    },
  },
  watch: {
    bill() {
      if (this.bill !== '') store.commit(SET_BILL, { value: this.bill });
    },
    numberOfPeople() {
      if (this.numberOfPeople !== '')
        store.commit(SET_NUMBER_OF_PEOPLE, { value: this.numberOfPeople });
    },
  },
});
</script>

<style lang="scss">
.inputs {
  color: $darker-cyan;

  & > *:not(:last-child):not(label) {
    margin-bottom: 1.5rem;
  }

  label {
    font-weight: 700;
  }
}
</style>
